module.exports = __webpack_public_path__ + "img/tip.913a4bd1.svg";